<script setup lang="ts">
import { formatAddress } from "@/contacts/formatAddress";
import type { ContactListItem, ContactQuery } from "@/contacts/types";
import { MapPin, User, UserCrown, UserStar } from "@iconoir/vue";
import { computed } from "vue";

const props = defineProps<{
  contact: ContactListItem | ContactQuery;
}>();

const contactAddress = computed(() =>
  formatAddress(props.contact.address, props.contact.apartment),
);
</script>

<template>
  <dl>
    <div>
      <dt><MapPin /><span class="visually-hidden">Adresse</span></dt>
      <dd>{{ contactAddress }}</dd>
    </div>
    <template v-if="contact.isHouseSpeaker === true">
      <div>
        <dt class="visually-hidden">Funktion</dt>
        <dd><UserCrown color="var(--icon-color-yellow)" />Haussprecher:in</dd>
      </div>
    </template>
    <template v-if="contact.isPotentialCoreActivist === true">
      <div>
        <dt class="visually-hidden">Aktivenstatus</dt>
        <dd>
          <UserStar color="var(--icon-color-green)" />potentielle:r Kernaktive:r
        </dd>
      </div>
    </template>
    <template v-if="contact.hasNoInterestInBecomingActive === true">
      <div>
        <dt class="visually-hidden">Aktivenstatus</dt>
        <dd><User color="var(--icon-color-red)" />kein Interesse</dd>
      </div>
    </template>
    <template v-if="contact.createdByUsername != null">
      <div>
        <dt>angelegt von:</dt>
        <dd>{{ contact.createdByUsername }}</dd>
      </div>
    </template>
  </dl>
</template>

<style scoped>
dd > svg {
  margin-inline-end: var(--spacing-sm);
}
</style>
